module.exports = __webpack_public_path__ + "static/media/customer-details-chama.d60b0a05.png";